import { type TEventOverrides, withEventOverrides } from 'shared/lib/sendGAEvents/lib/withEventOverrides';

import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Попап с согласиями на рекламу и обработку данных

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export const eventOpenConsentsScreen = (overrides?: TEventOverrides): IInitialEvent =>
  withEventOverrides(
    {
      event: EVENT_TYPE,
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Показ',
      eventLabel: 'Согласие на рекламу и обработку',
      eventValue: undefined,
    },
    overrides,
  );

export const eventConsentsScreenButtonClick = (
  agreementAdvertising: boolean,
  agreementPersonalData: boolean,
  isSubmitted: boolean,
  overrides?: TEventOverrides,
): IInitialEvent => {
  const eventLabel = ['Согласие на рекламу и обработку'];

  if (isSubmitted) {
    if (agreementPersonalData && !agreementAdvertising) {
      eventLabel.push('Без галочки');
    }
  } else {
    eventLabel.push('Без галочки после клика');
  }

  return withEventOverrides(
    {
      event: EVENT_TYPE,
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Клик',
      eventLabel,
      eventValue: undefined,
    },
    overrides,
  );
};

export const eventOnDisableAgreementPersonalData = (overrides?: TEventOverrides): IInitialEvent =>
  withEventOverrides(
    {
      event: EVENT_TYPE,
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Клик',
      eventLabel: 'Согласие на рекламу и обработку | Без галочки | Снял согласие обработки',
      eventValue: undefined,
    },
    overrides,
  );

export const eventOnEnableAgreementAdvertising = (overrides?: TEventOverrides): IInitialEvent =>
  withEventOverrides(
    {
      event: EVENT_TYPE,
      eventCategory: EVENT_CATEGORY,
      eventAction: 'Клик',
      eventLabel: 'Согласие на рекламу и обработку | Поставил галочку',
      eventValue: undefined,
    },
    overrides,
  );
